import React from 'react';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormRadio from 'components/forms/FormRadio';

export default class CmsElementVideo extends React.Component {
  setSwitcheryParam = (name, value) => {
    const { setParam } = this.props;
    setParam(name, value || 'no');
  };

  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
      navigateBack,
    } = this.props;

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.video}</b>
        </div>

        <div class="form-group-attached">
          <FormInput
            label={messages.link_to_video}
            value={getParamValue('videoUrl')}
            name="videoUrl"
            onChange={setParam}
            infoText={messages.video_possible_sources}
          />
          <div class="form-group form-group-default padding-10">
            <FormSwitchery
              name="videoAutoplay"
              label={messages.autoplay}
              checked={getParamValue('videoAutoplay') === 'yes'}
              value="yes"
              onChange={this.setSwitcheryParam}
            />
          </div>
          <FormRadio
            label={messages.aspect_ratio}
            options={[{ label: '16:9', value: '16-9' }, { label: '4:3', value: '4-3' }]}
            onChange={setParam}
            value={getParamValue('videoAspectRatio', '16-9')}
            name="videoAspectRatio"
          />
        </div>
      </>
    );
  }
}
